import Vue from 'vue';
import Vuex from 'vuex';
import ky from 'ky';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    movies: [],
  },
  getters: {
    billboardMovies: state => state.movies.filter(movie => movie.category[0] === 'now-playing'),
    comingMovies: state => state.movies.filter(movie => movie.category[0] === 'coming-soon').reverse(),
  },
  mutations: {
    setMovies(state, movies) {
      state.movies = movies;
    },
  },
  actions: {
    async getMovies({ commit }) {
      const fields = 'id,movie-name,short-plot,synopsis,runtime,year,rating,showtimes,trailer,details,poster,logo,backdrop,preview,show-in-carousel,category';
      const movies = await ky.get(`http://admin.cineflick.com.gt/wp-json/wp/v2/movie?_fields=${fields}`).json();
      commit('setMovies', movies);
    },
  },
});
